module.exports = __webpack_public_path__ + "static/img/非税票据.8c4e978.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/非税票据.png
// module id = ls6O
// module chunks = 2